import { OHAIO_API_URL } from '@/constants/value.js'

export async function useRoomInfo({ roomId, baseUrl = OHAIO_API_URL } = {}) {
  const url = `${baseUrl}/v1/transcription/room-info/${roomId}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
}